import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { toast } from 'react-toastify'

import { getURLToDownloadFile } from '@/services/get-url-to-download-file'
import { zipShapefileBufferToGeoJson } from '@/utils/file-conversions'

const GET_PERIMETER_DATA_QUERY_KEY = 'get-perimeter-data'

export function useGetPerimeterData(diagnosisId: string) {
  return useQuery({
    queryKey: [GET_PERIMETER_DATA_QUERY_KEY, diagnosisId],
    queryFn: async () => {
      const url = await getURLToDownloadFile('cane', diagnosisId, 'perimeter')

      const { data: shapefileZipBuffer } = await axios.get<ArrayBuffer>(url, {
        responseType: 'arraybuffer',
      })

      const geojson = await zipShapefileBufferToGeoJson(shapefileZipBuffer)
      return geojson
    },
    onError: (error: Error) => {
      toast.error(`Erro ao baixar o perímetro: ${error?.message}`)
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
